module.exports = __webpack_public_path__ + "static/media/arrow.5938b141.svg";